import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'dibs-react-intl';
import styles from '../../styles/main.scss';

// components
import Select from '../inputs/Select';

const messages = defineMessages({
    placeholder: {
        id: 'dc.AddressForm.StateUS.placeholder',
        defaultMessage: 'State*',
    },
});

const StateUS = ({ value, options, fieldSize, isBlurred, disabled, error, onChange, onBlur }) => {
    const intl = useIntl();
    return (
        <Select
            name="state"
            dataTn="state"
            value={value}
            autoComplete="state"
            wrapperClass={styles.leftGroup}
            options={options}
            placeholder={value ? '' : intl.formatMessage(messages.placeholder)}
            fieldSize={fieldSize}
            isBlurred={isBlurred}
            disabled={disabled}
            error={error}
            onChange={onChange}
            onBlur={onBlur}
        />
    );
};

StateUS.propTypes = {
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    options: PropTypes.array.isRequired,
    fieldSize: PropTypes.oneOf(['small', 'medium', 'large']),
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
};

StateUS.defaultProps = {
    onBlur() {},
};

export default StateUS;
